import createReactClass from 'create-react-class';
import _ from 'lodash';
import Moment from 'moment';
import React from 'react';
import PublishMixin from '../../mixins/publish-mixin';
import ReadOnly from '../clinical/read-only';
import Label from '../general/label';

export default createReactClass({
  displayName: 'calculated-label',
  mixins: [PublishMixin],

  getDefaultProps() {
    return {
      type: '',
      className: '',
      prefix: '',
      postfix: ''
    };
  },

  calculateBMI(height, weight) {
    let desc;
    if (!(height > 0 && weight > 0)) {
      return <ReadOnly value={null} />;
    }

    const cm = height / 100;
    const bmi = (weight / cm / cm).toFixed(1);

    switch (bmi > 0) {
      case bmi < 18.5:
        desc = <span className="weight underweight">{' Underweight'}</span>;
        break;
      case bmi >= 18.5 && bmi < 25:
        desc = <span className="weight normal-weight">{' Normal Weight'}</span>;
        break;
      case bmi >= 25 && bmi < 30:
        desc = <span className="weight overweight">{' Overweight'}</span>;
        break;
      case bmi >= 30 && bmi < 40:
        desc = <span className="weight obese">{' Obese'}</span>;
        break;
      case bmi >= 40:
        desc = <span className="weight very-obese">{' Very Obese'}</span>;
        break;
    }

    return (
      <span>
        <ReadOnly value={bmi} />
        <span className="bmi-control">{desc}</span>
      </span>
    );
  },

  render() {
    const className = this.props.className || '';
    let res = null;

    if (this.props.func === 'bmi') {
      res = this.calculateBMI(this.props.height || 0, this.props.weight || 0);
    } else {
      res = `${this.props.value} ${this.props.unit || this.props.valueUnit || ''}`;
    }

    return <span>{res}</span>;
  }
});
